import { isNil, noop, omit, stubFalse } from 'lodash';
import { gtmTracker } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { performanceMetricDataApi } from 'services/api/performanceMetricDataApi/performanceMetricDataApi';
import { APP_EVENT_TYPE } from '../../app-events-aggregator';
import { getTraceMetricAttributes } from '../utils/getTraceMetricAttributes';
import { getTraceProcessingTime, NANO_COEFFICIENT } from '../utils/getTraceProcessingTime';
import { TRACER_STATUS_CODE } from '../utils/tracerStatusCode';
import { SPAN_SCOPE } from './spanScope';

const WARNING_TIMEOUT_THRESHOLD = 55 * NANO_COEFFICIENT;
const VALUABLE_SKIP_THRESHOLD = 5 * NANO_COEFFICIENT;

export class CustomSpanMetricProcessor {
    constructor(normalizeSpanAttributes = stubFalse, pushAppEvent) {
        this.normalizeSpanAttributes = normalizeSpanAttributes;
        this.onStart = noop;
        this.pushAppEvent = pushAppEvent;
    }

    onEnd(span) {
        if (!SPAN_SCOPE[span.name] || !isNil(span.parentId) || !span.attributes) {
            return;
        }

        const processingTime = getTraceProcessingTime(span);

        if (span.status.code === TRACER_STATUS_CODE.UNSET && processingTime < VALUABLE_SKIP_THRESHOLD) {
            return;
        }

        const transformedSpan = this.normalizeSpanAttributes(span);
        if (!transformedSpan) {
            return;
        }

        const metricAttributes = getTraceMetricAttributes(transformedSpan);

        if (processingTime > WARNING_TIMEOUT_THRESHOLD) {
            const errorMessage = `Span duration is more than timeout threshold (reportId-${
                span?.attributes?.reportId
            }, spanId-${span.spanContext()?.spanId}, traceId-${span.spanContext()?.traceId}): ${(
                processingTime / NANO_COEFFICIENT
            ).toFixed(2)}s (${WARNING_TIMEOUT_THRESHOLD / NANO_COEFFICIENT}s), rrand-${span?.attributes?.rrand}`;
            const eventData = {
                traceId: span.spanContext()?.traceId,
                spanId: span.spanContext()?.spanId,
                ...omit(span.attributes, ['appEventProperties']),
            };
            this.pushAppEvent({
                type: APP_EVENT_TYPE.PERFORMANCE_MEASUREMENT,
                id: span.name,
                status: metricAttributes.status,
                value: `${processingTime / NANO_COEFFICIENT}`,
                data: eventData,
            });
            gtmTracker.trackError(new Error(errorMessage));
        }

        performanceMetricDataApi.updatePerformanceMetricData({
            value: processingTime,
            labelData: metricAttributes,
        });
    }
}
